import { DividerStoryblok } from '@monoimin/sb-types';

interface DividerProps extends ComponentCommonProps {
  blok?: DividerStoryblok;
  height?: keyof typeof heights;
}
const heights = {
  large: { desktop: 100, mobile: 60 },
};
export function Divider({ blok, isSection, gapSizeInPixels }: DividerProps) {
  const expectedHeight =
    heights[blok?.height as keyof typeof heights] ?? heights.large;

  const mobileHeight =
    isSection && gapSizeInPixels
      ? expectedHeight.mobile - gapSizeInPixels * 2
      : expectedHeight.mobile;

  const desktopHeight =
    isSection && gapSizeInPixels
      ? expectedHeight.desktop - gapSizeInPixels * 2
      : expectedHeight.desktop;

  return (
    <>
      <hr
        className='container  opacity-0 hidden md:block'
        style={{ height: `${desktopHeight}px` }}
      />
      <hr
        className='container  opacity-0 md:hidden block'
        style={{ height: `${mobileHeight}px` }}
      />
    </>
  );
}
